import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import CircularProgress from "@mui/material/CircularProgress";
const LoadingSpinner = ({
  classes,
  overlayParent = false,
  color = "secondary",
  size = 50
}) => {
  const spinner = /*#__PURE__*/React.createElement(CircularProgress, {
    size: size,
    style: {
      alignSelf: "center"
    },
    color: color
  });
  if (overlayParent) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.loadingContainer
    }, spinner);
  }
  return spinner;
};
const styles = {
  loadingContainer: {
    // width: "100%",
    // height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    zIndex: "999999",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  }
};
export default withStyles(styles)(LoadingSpinner);
LoadingSpinner.propTypes = {
  classes: PropTypes.object.isRequired,
  overlayParent: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.number
};